import { Component } from '@theme/component';
import { morph } from '@theme/morph';

/**
 * A custom element handles scroll position in the page and shows or hides the atc
 * @typedef {object} Refs
 * @property {HTMLSpanElement[]} [variant_value] - The image that's tab controlled
 * @property {HTMLSpanElement} [price] - The content that's tab controlled. Either the images or the content should be there, but not both.
 *
 * @extends {Component<Refs>}
 */
class StickyFooter extends Component {
  constructor() {
    super();
  }
  connectedCallback() {
    this.refs = {};
    this.querySelectorAll('[ref]').forEach((el) => {
      const name = el.getAttribute('ref');
      if (this.refs[name]) {
        // If already exists, convert to array
        if (!Array.isArray(this.refs[name])) {
          this.refs[name] = [this.refs[name]];
        }
        this.refs[name].push(el);
      } else {
        this.refs[name] = el;
      }
    });
    this.refs.variant_value = this.querySelectorAll('[ref^="variant_value-"]');
    this.main = document.querySelector('main');
    this.footer = document.querySelector('footer');
    this.header = document.querySelector('#header-group');
    this.productForm = document.querySelector('.product-information');
    this.isInitialLoad = true;
    this.setup();
  }

  setup() {
    const mainAtcButton = document.querySelector('[ref="addToCartButton"]');

    if (!this.footer || !mainAtcButton) return;

    let isButtonVisible = true;
    let isFooterVisible = false;

    const handleIntersection = (entries) => {
      entries.forEach((entry) => {
        if (entry.target === mainAtcButton) {
          // entry.boundingClientRect.top < 0 means it scrolled UP off the screen
          const isButtonPastTop = entry.boundingClientRect.top < 0;
          const isCurrentlyVisible = entry.isIntersecting;

          isButtonVisible = isCurrentlyVisible || !isButtonPastTop;
        }
        if (entry.target === this.footer) {
          isFooterVisible = entry.isIntersecting;
        }
      });

      // LOGIC: Show if the main button is GONE and the footer is NOT yet here
      if (!isButtonVisible && !isFooterVisible) {
        this.classList.remove('tw-sticky-pdp-footer--hidden');
      } else {
        this.classList.add('tw-sticky-pdp-footer--hidden');
      }
    };

    const observer = new IntersectionObserver(handleIntersection, {
      threshold: 0, // Trigger as soon as 1 pixel enters/leaves
    });

    observer.observe(mainAtcButton);
    observer.observe(this.footer);
  }
}
if (!customElements.get('sticky-footer')) {
  customElements.define('sticky-footer', StickyFooter);
}
